import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

// Le jeton d'accès vit 1 h ; au premier 401 on tente un rafraîchissement
// silencieux (cookie refresh_token 7/90 jours) puis on rejoue la requête.
let _refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    const url = config?.url || "";
    const noRetry = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/google/session", "/auth/logout"];
    if (response?.status === 401 && config && !config._retried && !noRetry.some((p) => url.includes(p))) {
      config._retried = true;
      _refreshing = _refreshing || api.post("/auth/refresh").finally(() => { _refreshing = null; });
      try {
        await _refreshing;
        return api(config);
      } catch { /* session expirée pour de bon */ }
    }
    // IP bloquée par le propriétaire (bouton « Bloquer » de l'historique des
    // visiteurs, 2026-10-16) : le site complet affiche la page d'accès refusé
    if (response?.status === 403 && response?.data?.detail === "Accès refusé"
        && !window.location.pathname.startsWith("/bloque")) {
      window.location.assign("/bloque");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

let _locale = "fr-CA";  // basculé par LanguageContext (fmt suit la langue du site)
export function setFmtLocale(lang) { _locale = lang === "en" ? "en-CA" : "fr-CA"; }

export const fmt = (n) => {
  const v = Number(n || 0);
  if (_locale === "en-CA") return `$${v.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return v.toLocaleString("fr-CA", { style: "currency", currency: "CAD" });
};

// Suivi des clics « Soumission en 30 secondes » (demande du propriétaire,
// 2026-10-17) : chaque bouton déclare sa source (accueil, catalogues, forfaits,
// fiche, blogue, pastille) — agrégé par jour côté serveur, jamais bloquant.
// La source est MÉMORISÉE (session) : si le visiteur envoie la soumission, elle
// est attribuée à ce bouton → taux de conversion par endroit dans l'admin.
export function trackClicSoumission(source) {
  try { sessionStorage.setItem("mt_clic_source", source); } catch { /* navigation privée stricte */ }
  try { api.post("/analytics/clic-soumission", { source }).catch(() => {}); } catch { /* jamais bloquant */ }
}
